{
  "familyId": "MET-INH-OMREKEN",
  "questions": [
    {
      "id": "MET-INH-OMREKEN-001",
      "familyId": "MET-INH-OMREKEN",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "inhoud",
      "subSkill": "inhoud_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een kok heeft 2,5 liter bouillon nodig. Het recept staat in milliliter. Hoeveel milliliter is dat?",
      "options": ["2500 ml", "250 ml", "25 ml", "25000 ml"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "volume",
            "from": "l",
            "to": "ml",
            "unit": "liter",
            "steps": ["ml", "cl", "dl", "l"],
            "highlight": true,
            "label": "Van liter naar milliliter: 3 stappen naar beneden (×1000)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Inhoud omrekenen",
            "content": "Het metrieke trapje voor inhoud: l → dl → cl → ml. Elke stap naar beneden is ×10. Van liter naar milliliter = 3 stappen = ×1000. Dus 2,5 l = 2,5 × 1000 = 2500 ml.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoud_liter_ml",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.inhoud-trede-te-weinig", "label": "Eén stap te weinig (×100 i.p.v. ×1.000)", "optionIndex": 1 },
          { "id": "met.inhoud-trede-te-weinig", "label": "Twee stappen te weinig (×10 i.p.v. ×1.000)", "optionIndex": 2 },
          { "id": "met.inhoud-trede-te-veel", "label": "Eén stap te veel (×10.000)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Van liter naar milliliter ga je 3 stappen naar beneden op het metrieke trapje (l → dl → cl → ml). Elke stap is ×10, dus totaal ×1000. De kok rekent: 2,5 × 1000 = 2500 ml. Onthoud: van liter naar milliliter is altijd ×1000.",
        "solutionSteps": [
          "l → dl → cl → ml = 3 stappen naar beneden",
          "Elke stap = ×10, dus 3 stappen = ×1000",
          "2,5 × 1000 = 2500 ml"
        ],
        "distractorExplanations": {
          "0": "Goed! 2,5 liter = 2500 milliliter.",
          "1": "Je dacht waarschijnlijk dat je ×100 doet (2 stappen). Maar van l naar ml zijn het 3 stappen: l → dl → cl → ml = ×10 × 10 × 10 = ×1000. Dus 2,5 × 1000 = 2500 ml. Onthoud: tel de treden op het trapje.",
          "2": "Je dacht waarschijnlijk dat je ×10 doet (1 stap). Maar van l naar ml zijn het 3 stappen (×1000), niet 1 stap (×10). Onthoud: l → ml = 3 treden = ×1000.",
          "3": "Je dacht waarschijnlijk dat je ×10000 doet (4 stappen). Maar van l naar ml zijn het 3 stappen (×1000), niet 4. Onthoud: tel de treden: l → dl → cl → ml = 3."
        }
      }
    },
    {
      "id": "MET-INH-OMREKEN-002",
      "familyId": "MET-INH-OMREKEN",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "inhoud",
      "subSkill": "inhoud_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een apotheker meet 750 ml vloeistof af. Hoeveel deciliter is dat?",
      "options": ["75 dl", "0,75 dl", "7,5 dl", "750 dl"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "volume",
            "from": "ml",
            "to": "dl",
            "unit": "liter",
            "steps": ["ml", "cl", "dl", "l"],
            "highlight": true,
            "label": "Van ml naar dl: 2 stappen omhoog (÷100)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van ml naar dl",
            "content": "Van ml naar dl ga je 2 stappen omhoog op het trapje (ml → cl → dl). Elke stap omhoog = ÷10. Dus 2 stappen = ÷100. 750 ÷ 100 = 7,5 dl.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoud_ml_dl",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.inhoud-trede-te-weinig", "label": "Eén stap te weinig (÷10 i.p.v. ÷100)", "optionIndex": 0 },
          { "id": "met.inhoud-trede-te-veel", "label": "Eén stap te veel (÷1.000 i.p.v. ÷100)", "optionIndex": 1 },
          { "id": "met.inhoud-richting-omgedraaid", "label": "Niet gedeeld (klein → groot = ÷)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Van ml naar dl ga je 2 stappen omhoog: ml → cl → dl. Elke stap = ÷10, dus 2 stappen = ÷100. De apotheker rekent: 750 ÷ 100 = 7,5 dl. Onthoud: omhoog op het trapje = delen.",
        "solutionSteps": [
          "ml → cl → dl = 2 stappen omhoog",
          "Elke stap = ÷10, dus 2 stappen = ÷100",
          "750 ÷ 100 = 7,5 dl"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je maar 1 stap omhoog gaat (/10). Maar van ml naar dl zijn het 2 stappen: ml, cl, dl = /100. Dus 750 / 100 = 7,5 dl.",
          "1": "Je dacht waarschijnlijk dat je 3 stappen omhoog gaat (/1000). Maar van ml naar dl zijn het maar 2 stappen (/100). Onthoud: ml, cl, dl = 2 treden.",
          "2": "Goed! 750 ml = 7,5 dl.",
          "3": "Je dacht waarschijnlijk dat je niet hoeft te delen. Maar van klein (ml) naar groot (dl) krijg je minder, dus deel je. Onthoud: klein naar groot = delen."
        }
      }
    },
    {
      "id": "MET-INH-OMREKEN-003",
      "familyId": "MET-INH-OMREKEN",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "inhoud",
      "subSkill": "inhoud_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een barista schenkt een drankje van 33 cl in. Hoeveel liter is dat?",
      "options": ["3,3 l", "0,33 l", "33 l", "0,033 l"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "volume",
            "from": "cl",
            "to": "l",
            "unit": "liter",
            "steps": ["ml", "cl", "dl", "l"],
            "highlight": true,
            "label": "Van cl naar l: 2 stappen omhoog (÷100)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van cl naar l",
            "content": "Van cl naar l ga je 2 stappen omhoog: cl → dl → l. Elke stap = ÷10, dus 2 stappen = ÷100. 33 ÷ 100 = 0,33 l.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoud_cl_liter",
      "variantIndex": 3,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.inhoud-trede-te-weinig", "label": "Eén stap te weinig (÷10 i.p.v. ÷100)", "optionIndex": 0 },
          { "id": "met.inhoud-richting-omgedraaid", "label": "Geen omrekening uitgevoerd", "optionIndex": 2 },
          { "id": "met.inhoud-trede-te-veel", "label": "Eén stap te veel (÷1.000 i.p.v. ÷100)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Van cl naar l ga je 2 stappen omhoog (cl → dl → l). Elke stap = ÷10, dus ÷100 totaal. 33 ÷ 100 = 0,33 l. Een blikje frisdrank is dus ongeveer ⅓ liter. Onthoud: cl → l = 2 treden omhoog = ÷100.",
        "solutionSteps": [
          "cl → dl → l = 2 stappen omhoog",
          "2 stappen = ÷100",
          "33 ÷ 100 = 0,33 l",
          "Controleer: 0,33 l ≈ ⅓ liter — dat klopt voor een blikje ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je maar 1 stap omhoog gaat (/10). Maar van cl naar l zijn het 2 stappen: cl, dl, l = /100. Dus 33 / 100 = 0,33 l.",
          "1": "Goed! 33 cl = 0,33 liter.",
          "2": "Je dacht waarschijnlijk dat je helemaal niet hoeft om te rekenen. Maar 33 cl is niet 33 l. Van cl naar l moet je /100.",
          "3": "Je dacht waarschijnlijk dat je 3 stappen omhoog gaat (/1000). Maar van cl naar l zijn het maar 2 stappen (/100). Onthoud: cl, dl, l = 2 treden."
        }
      }
    },
    {
      "id": "MET-INH-OMREKEN-004",
      "familyId": "MET-INH-OMREKEN",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "inhoud",
      "subSkill": "inhoud_omrekenen",
      "questionType": "multiple_choice",
      "question": "Een laborant vergelijkt vier vloeistoffen. Welke hoeveelheid is het GROOTST?",
      "options": ["12 dl", "1,2 l", "120 cl", "1500 ml"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "volume",
            "from": "ml",
            "to": "l",
            "unit": "liter",
            "steps": ["ml", "cl", "dl", "l"],
            "highlight": true,
            "label": "Inhoudsmaten: l → dl → cl → ml (elke stap ×10)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vergelijken door om te rekenen",
            "content": "Reken alles om naar dezelfde eenheid (bijv. ml): 1500 ml, 12 dl = 1200 ml, 1,2 l = 1200 ml, 120 cl = 1200 ml. 1500 ml is het grootst.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoud_vergelijken",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.inhoud-vergelijken-zonder-omrekening", "label": "Vergeleken zonder om te rekenen (kiest hoogste getal)", "optionIndex": 0 },
          { "id": "met.inhoud-grootste-eenheid-gekozen", "label": "Kiest grootste eenheid (l) als 'meest'", "optionIndex": 1 },
          { "id": "met.inhoud-vergelijken-zonder-omrekening", "label": "Hoogste getal gekozen zonder omrekenen", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "Om hoeveelheden te vergelijken, reken je alles om naar dezelfde eenheid. In ml: 1500 ml = 1500, 12 dl = 1200 ml, 1,2 l = 1200 ml, 120 cl = 1200 ml. 1500 ml is het grootst. Let op: 12 dl, 1,2 l en 120 cl zijn allemaal even veel! Onthoud: bij vergelijken altijd eerst omrekenen naar dezelfde eenheid.",
        "solutionSteps": [
          "Kies één eenheid om naar om te rekenen: ml",
          "1500 ml = 1500 ml",
          "12 dl = 12 × 100 = 1200 ml",
          "1,2 l = 1,2 × 1000 = 1200 ml",
          "120 cl = 120 × 10 = 1200 ml",
          "1500 > 1200 → 1500 ml is het grootst ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 12 dl het meest is omdat 12 een hoog getal lijkt. Maar 12 dl = 1200 ml, en 1500 ml is meer. Onthoud: vergelijk altijd in dezelfde eenheid.",
          "1": "Je dacht waarschijnlijk dat 1,2 l het meest is omdat liter de grootste eenheid is. Maar 1,2 l = 1200 ml, en 1500 ml is meer. Onthoud: een groot getal in een kleine eenheid kan meer zijn.",
          "2": "Je dacht waarschijnlijk dat 120 cl het meest is omdat 120 een hoog getal is. Maar 120 cl = 1200 ml, en 1500 ml is meer. Onthoud: reken altijd om naar dezelfde eenheid.",
          "3": "Goed! 1500 ml is het grootst (de andere drie zijn allemaal 1200 ml)."
        }
      }
    },
    {
      "id": "MET-INH-OMREKEN-005",
      "familyId": "MET-INH-OMREKEN",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "inhoud",
      "subSkill": "inhoud_omrekenen",
      "questionType": "fill_in",
      "question": "Een dierenarts heeft 3,5 dl medicijn. Hoeveel milliliter is dat? Typ het getal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["350"],
        "caseSensitive": false,
        "placeholder": "... ml"
      },
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "volume",
            "from": "dl",
            "to": "ml",
            "unit": "liter",
            "steps": ["ml", "cl", "dl", "l"],
            "highlight": true,
            "label": "Van dl naar ml: 2 stappen naar beneden (×100)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van dl naar ml",
            "content": "Van dl naar ml ga je 2 stappen naar beneden op het trapje: dl → cl → ml. Elke stap = ×10, dus 2 stappen = ×100. 3,5 × 100 = 350 ml.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoud_dl_ml_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 1,
        "hasStructuredData": true
      },
      "feedback": {
        "explanationText": "Van dl naar ml ga je 2 stappen naar beneden (dl → cl → ml). Elke stap = ×10, dus 2 stappen = ×100. De dierenarts rekent: 3,5 × 100 = 350 ml. Onthoud: dl → ml = 2 treden naar beneden = ×100.",
        "solutionSteps": [
          "dl → cl → ml = 2 stappen naar beneden",
          "2 stappen = ×100",
          "3,5 × 100 = 350 ml"
        ]
      }
    },
    {
      "id": "MET-INH-OMREKEN-006",
      "familyId": "MET-INH-OMREKEN",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "inhoud",
      "subSkill": "inhoud_omrekenen",
      "questionType": "step_solver",
      "question": "Een tuinman heeft 4,2 liter plantenvoeding. Het etiket zegt: gebruik 300 ml per plant. Voor hoeveel planten is dit genoeg? Los stap voor stap op.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "stepSolver": {
          "context": "Plantenvoeding: 4,2 l beschikbaar, 300 ml per plant.",
          "steps": [
            { "prompt": "Reken 4,2 liter om naar milliliter. Hoeveel ml is 4,2 l?", "correctAnswer": "4200", "acceptedAnswers": ["4200", "4.200"], "hint": "l → ml = 3 stappen = ×1000. Dus 4,2 × 1000 = ?" },
            { "prompt": "Deel het aantal ml door 300 (verbruik per plant). Voor hoeveel planten is het genoeg?", "correctAnswer": "14", "acceptedAnswers": ["14", "14 planten"], "hint": "4200 ÷ 300 = 42 ÷ 3 = ?" }
          ],
          "showStepsProgressively": true
        }
      },
      "stimulusAids": [
        { "type": "stairs", "data": { "type": "volume", "from": "l", "to": "ml", "unit": "liter", "steps": ["ml", "cl", "dl", "l"], "highlight": true, "label": "Van liter naar milliliter: 3 stappen (×1000)" } }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Omrekenen + delen", "content": "Stap 1: 4,2 l = 4200 ml (×1000). Stap 2: 4200 ÷ 300 = 14 planten.", "icon": "lightbulb" } }
      ],
      "conceptId": "inhoud_step_solver_context",
      "variantIndex": 6,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.71,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Stap 1: Reken om naar ml: 4,2 l × 1000 = 4200 ml. Stap 2: Deel door het verbruik per plant: 4200 ÷ 300 = 14. De tuinman heeft genoeg voor 14 planten.",
        "solutionSteps": [
          "l → ml = 3 stappen = ×1000",
          "4,2 × 1000 = 4200 ml",
          "4200 ÷ 300 = 14 planten"
        ]
      }
    }
  ]
}